/**
 * cart-drawer-corner-fix.js
 *
 * Problema: la app Corner (usecorner.io) sigue inyectando un script en la tienda
 * que sobrescribe CartDrawer.prototype.open() y ese método sobrescrito truena
 * ("Cannot read properties of undefined (reading 'set')"), dejando el carrito
 * nativo sin poder abrir.
 *
 * Solución: interceptamos el clic en fase de "captura" (antes de que llegue al
 * elemento y dispare cualquier listener de Corner o del tema) y abrimos/cerramos
 * el drawer manipulando las clases directamente, sin llamar a .open()/.close().
 *
 * Esto es temporal mientras se decide si desinstalar Corner por completo.
 * Cuando se desinstale, este archivo puede seguir activo sin ningún problema
 * (simplemente no habrá nada que interceptar/romper).
 */

(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openDrawer(triggeredBy) {
    const drawer = getDrawer();
    if (!drawer) return;

    if (triggeredBy) {
      drawer.__bijouTriggeredBy = triggeredBy;
    }

    requestAnimationFrame(() => {
      drawer.classList.add('animate', 'active');
    });

    document.body.classList.add('overflow-hidden', 'bijou-cart-drawer-open');

    // Refresca el estado del carrito por si Corner alcanzó a modificar algo
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function cleanupOverlays() {
    document.body.classList.remove('overflow-hidden', 'bijou-cart-drawer-open', 'gift-picker-open');

    if (window.BijouCartAddons && window.BijouCartAddons.closeAddonsStep) {
      window.BijouCartAddons.closeAddonsStep();
    }

    const giftModal = document.querySelector('[data-gift-picker-modal]');
    if (giftModal) giftModal.hidden = true;
  }

  function initDrawerCloseObserver() {
    const drawer = getDrawer();
    if (!drawer || drawer.dataset.bijouCloseObserverInit) return;
    drawer.dataset.bijouCloseObserverInit = 'true';

    let wasActive = drawer.classList.contains('active');

    const observer = new MutationObserver(() => {
      const isActive = drawer.classList.contains('active');
      if (wasActive && !isActive) {
        // El carrito se acaba de cerrar, sin importar qué lo haya cerrado
        // (botón X, overlay, tecla Escape, u otro mecanismo del tema)
        cleanupOverlays();
      }
      wasActive = isActive;
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden', 'bijou-cart-drawer-open', 'gift-picker-open');

    // Asegura que ninguna pantalla flotante (add-ons, selector de regalo) se
    // quede visible independientemente del carrito, ya que usan position:fixed
    if (window.BijouCartAddons && window.BijouCartAddons.closeAddonsStep) {
      window.BijouCartAddons.closeAddonsStep();
    }
    const giftModal = document.querySelector('[data-gift-picker-modal]');
    if (giftModal) giftModal.hidden = true;

    if (drawer.__bijouTriggeredBy) {
      drawer.__bijouTriggeredBy.focus();
      drawer.__bijouTriggeredBy = null;
    }
  }

  // Fase de captura = se ejecuta ANTES que cualquier listener normal
  // (incluyendo el que Corner haya inyectado), así que ganamos la carrera
  // sin importar el orden en que se cargaron los scripts.
  document.addEventListener(
    'click',
    function (e) {
      const cartIcon = e.target.closest('#cart-icon-bubble');
      if (cartIcon) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer(cartIcon);
        return;
      }

      const closeTrigger = e.target.closest('.drawer__close, #CartDrawer-Overlay');
      if (closeTrigger && closeTrigger.closest('cart-drawer')) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      }
    },
    true // <- capture phase
  );

  // Cerrar con la tecla Escape
  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      const drawer = getDrawer();
      if (drawer && drawer.classList.contains('active')) {
        closeDrawer();
      }
    }
  });

  // Salvaguarda: si el usuario navega a cualquier link del sitio sin cerrar
  // explícitamente el carrito o el selector de regalo primero, nos aseguramos
  // de que el scroll del body nunca se quede bloqueado.
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const giftModal = document.querySelector('[data-gift-picker-modal]');
    if (giftModal && !giftModal.hidden) {
      giftModal.hidden = true;
    }

    if (window.BijouCartAddons && window.BijouCartAddons.closeAddonsStep) {
      window.BijouCartAddons.closeAddonsStep();
    }

    const drawer = getDrawer();
    if (drawer) drawer.classList.remove('active');

    document.body.classList.remove('overflow-hidden', 'bijou-cart-drawer-open', 'gift-picker-open');
  });

  function forceCleanBodyState() {
    const drawer = getDrawer();
    const drawerIsActive = drawer && drawer.classList.contains('active');
    if (!drawerIsActive) {
      document.body.classList.remove('overflow-hidden', 'bijou-cart-drawer-open', 'gift-picker-open');
    }
  }

  // Se dispara al mostrar la página, incluyendo cuando el navegador la restaura
  // desde caché (bfcache) o desde un sistema de precarga/prerender del tema.
  window.addEventListener('pageshow', forceCleanBodyState);

  // Se dispara justo antes de salir de la página, por si el sistema de
  // precarga conserva el estado del body entre navegaciones.
  window.addEventListener('pagehide', function () {
    document.body.classList.remove('overflow-hidden', 'bijou-cart-drawer-open', 'gift-picker-open');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceCleanBodyState);
  } else {
    forceCleanBodyState();
  }

  window.BijouCartDrawerFix = { openDrawer, closeDrawer };

  // Inicializa el observador tan pronto como el <cart-drawer> exista en el DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerCloseObserver);
  } else {
    initDrawerCloseObserver();
  }
})();